export default "/images/caret.png?d590e75a8a25e193e3d748464bbcd236";